// https://masonry.desandro.com/
// https://imagesloaded.desandro.com/

import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'

var grid = document.querySelector('.js-Masonry')

if (grid) {
  var msnry = new Masonry( grid, {
    itemSelector: '.masonry__item',
    columnWidth: '.masonry__masonry-column-template',
    horizontalOrder: true
  })

  imagesLoaded( grid ).on( 'progress', function() {
    msnry.layout()
  })
}
